
import React from 'react'
import Header from '../Header/header'

function HeroSection() {
  return (
    <div className='w-full flex flex-col max-w-[400px] justify-center items-center gap-3 pb-2 emi-container'>
      <img src='/assets/img/Reviewwhite.png' loading='lazy' class="logo-header"/>
      <h1 className="emi-heading erstoria-text">
        Feeling the pressure of{" "}
        <span className="highlight-box">multiple EMIs</span> every month?
      </h1>

      <p className="emi-subtext erstoria-text">
        Stop the stress. There’s a <span className="emi-underline">smarter</span> way.
      </p>

      <div className="benefits-wrapper">
      <div className="benefit-card">
        <div className="benefit-icon"><img src='/assets/img/Layer_1.png' loading='lazy'/></div>
        <p class="boxes-font">
          Pay less EMI<br />
          every month
        </p>
      </div>

      <div className="benefit-card">
        <div className="benefit-icon"><img src='/assets/img/Layer_2.png' loading='lazy'/></div>
        <p class="boxes-font">
          Save big on<br />
          total interest
        </p>
      </div>

      <div className="benefit-card">
        <div className="benefit-icon"><img src='/assets/img/Layer_3.png' loading='lazy'/></div>
        <p class="boxes-font">
          Extra<br />
          Top up available
        </p>
      </div>
    </div>
    </div>
  )
}

export default HeroSection
